/**
 * DetailHeaderContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled container for the detail header row (clock and logo).
 */
const DetailHeaderContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  top: ${40 * Screen.widthRatio}px;
  right: ${40 * Screen.widthRatio}px;
  z-index: 1;
`;

export default DetailHeaderContainer;
